module.exports = __webpack_public_path__ + "img/logo-vision.c25b7641.svg";